const CLOSING_CLASS = "is-popover-closing"

const closingAnimations = new WeakMap()

export function cancelPopoverClose(element) {
  if (!element) return

  const active = closingAnimations.get(element)
  if (active) {
    clearTimeout(active.timeout)
    element.removeEventListener("animationend", active.finish)
    closingAnimations.delete(element)
  }
  element?.classList?.remove(CLOSING_CLASS)
}

export function closeWithPopoverMotion(element, close, { closingClass = CLOSING_CLASS } = {}) {
  if (!element) {
    close()
    return
  }

  cancelPopoverClose(element)

  if (prefersReducedMotion()) {
    close()
    return
  }

  element.classList.add(closingClass)

  const timeoutMs = animationTimeout(element)
  if (timeoutMs === 0) {
    element.classList.remove(closingClass)
    close()
    return
  }

  const finish = () => {
    const active = closingAnimations.get(element)
    if (active?.finish !== finish) return

    clearTimeout(active.timeout)
    element.removeEventListener("animationend", finish)
    closingAnimations.delete(element)
    element.classList.remove(closingClass)
    close()
  }

  const timeout = window.setTimeout(finish, timeoutMs)
  closingAnimations.set(element, { finish, timeout })
  element.addEventListener("animationend", finish)
}

export function prefersReducedMotion() {
  return window.matchMedia?.("(prefers-reduced-motion: reduce)").matches
}

function animationTimeout(element) {
  const styles = window.getComputedStyle(element)
  if (styles.animationName === "none") return 0

  const durations = styles.animationDuration.split(",").map(parseTime)
  const delays = styles.animationDelay.split(",").map(parseTime)
  const total = Math.max(
    ...durations.map((duration, index) => duration + (delays[index] ?? delays.at(-1) ?? 0)),
    0
  )

  return total > 0 ? total + 60 : 0
}

function parseTime(value) {
  const trimmed = value.trim()
  if (!trimmed) return 0
  if (trimmed.endsWith("ms")) return Number.parseFloat(trimmed) || 0
  if (trimmed.endsWith("s")) return (Number.parseFloat(trimmed) || 0) * 1000

  return Number.parseFloat(trimmed) || 0
}
